/**
 * Regex used to extract information from a stream chunk.
 * Matches lines like "Key: Value"
 *
 * Group 1 = key (letters only), Group 2 = value (rest of the line)
 */
export const EXTRACT_STREAMING_FIELDS_REGEX = /^([a-zA-Z]+):\s?(.*)$/gm;

/** Name given to a stream event by default */
export const DEFAULT_STREAM_EVENT_NAME = 'default' as const;

/** SSE events are separated by a blank line. */
export const SSE_FRAME_DELIMITER = '\n\n';
